import styles from "./SupportFooter.module.css";
import { ReactComponent as Lock } from "../../../assets/lock.svg";
import { ReactComponent as KlashaBlackLogo } from "../../../assets/logo-black.svg";

export const SupportEmail = () => {
  return (
    <div className={styles.contact}>
      {/* removed custom email per produc's requests */}
    </div>
  );
};

export const SupportFooter = () => {
  return (
    <div className={styles.container}>
      <div className={styles.secured}>
        <Lock />
        <p>Secured by</p>
        <KlashaBlackLogo />
      </div>
    </div>
  );
};
